import { render } from "./SkuRequestDetail.vue?vue&type=template&id=a0a182f0&scoped=true"
import script from "./SkuRequestDetail.vue?vue&type=script&lang=js"
export * from "./SkuRequestDetail.vue?vue&type=script&lang=js"

import "./SkuRequestDetail.vue?vue&type=style&index=0&id=a0a182f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a182f0"]])

export default __exports__